<template>
    <or-button
        class="train-btn"
        type="secondary"
        color="primary"
        size="small"
        icon="bug_report"
        :disabled="isDisabled"
        :loading="isTrainingForTest"
        @click="trainTestModel"
    >
      {{ $t('model.nlu-model.header.traintestmodelbutton.trainTestModel') }}
    </or-button>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('knowledgebase', ['categories']),
    ...mapState('knowledgebase/test', ['isTrainingForTest']),
    ...mapGetters('knowledgebase/statuses', ['isStatusFeatching']),

    isDisabled () {
      return this.isTrainingForTest || this.isStatusFeatching || _.isEmpty(this.categories.value)
    }
  },

  methods: {
    ...mapActions('knowledgebase/test', ['trainTestModel'])
  }
}
</script>

<style lang="scss" scoped>
    .train-btn {
        margin-right: $sp-3;
    }
</style>
